<template>
  <div class="kaoshi" v-loading="loading">
    <div class="title pf">
      <div :class="isBig?'width':'width1'">
        <div class="tr pt-15">考试结束时间：{{data.end_time}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;倒计时：{{ countDown }}</div>
        <p class="clearfix pt-5 pb-15">
            <span class="fl">试卷名称：<b class="fw-b f16">{{data.title}}</b></span>
            <span class="fr">总分：{{data.score}}分 &nbsp;&nbsp;&nbsp;&nbsp;( 单选题：100道)</span>
        </p>
      </div>
    </div>
    
    <div class="contanier pr" :class="isBig?'width':'width1'">
      <!-- 答题卡 -->
      <div class="left pf">
        <div class="top mb-20 pb-20">
          <h3>考生信息</h3>
          <p class="pl-20 mb-10 pt-15 c-6">考生姓名：{{ getLS('name') }}</p>
          <p class="pl-20 pb-15 c-6">身份证号：{{ getLS('id_card') }}</p>
        </div>
        <div class="bot">
          <h3>答题卡</h3>
          <el-scrollbar id='ansCard'>
          <ul class="clearfix">
            <li v-for="(item,index) in dataTest.shiti" :key="index" class="tc fl" :id='"is"+item.id' :class='{active:!!answer[index]}'  @click='setTo(item.id)'>{{index+1}}</li>
          </ul>   
          </el-scrollbar>
          <div class="pl-15 pr-15 pb-15">
            <el-button type="danger" round size='medium' :disabled='flag' @click="reqSubmit">交卷</el-button>
          </div>
        </div>
      </div>
      <!-- 试卷 -->
      <div class="right pr" :class="isBig?'r93':'r72'">
        <div v-for="(item,index) in dataTest.shiti" :key="index" :id='"to"+item.id' class="mb-15">
          <div class="tit mb-10">{{index+1}}、{{item.question}}</div>
          <img :src="item.img_url" v-if='item.img_url' />
          <el-radio-group v-model="answer[index]" @change = '(label)=>{ reqAnswer(label,item.id) }'>
            <el-radio v-for="(items,key,i) in JSON.parse(item.answer_options)" :key="i" :label="key+item.id" >{{key+'、'+items}}</el-radio>
          </el-radio-group>
        </div>  
      </div>
    </div>  
  </div>
</template>

<script>
  import qs from "qs";
  export default {
    name: "kaoshi",
    data() {
      return{
        loading:true,
        data:{},
        dataTest:{},
        answer:[],
        answers:[],
        obj:{
          uid: this.getLS('uid'),
          token: this.getLS('token'),
          shijuan_id: this.$route.query.shijuan_id
        },
        flag:true,
        isBig:true,
        TimeOutHalf:null,
        TimeEnd:null,
        timePlus:null,
        countDown:0,
        now:0
      }
    },
    mounted(){
      if(this.getLS('token')){
        
        this.reqTest()   
        for(let i=0;i<100;i++){
            this.answers[i] = {shiti_id:i+156,answer:''} 
          }
        if(screen.availWidth<1200){
          this.isBig = false
        }
        let h = (screen.availHeight - 450)+'px'
        document.getElementById('ansCard').style.height=h
      }else{
        this.$alert(' ', '请登录!', {
          confirmButtonText: '确定',
          showClose:false,
          center: true,
          callback: action => {
            this.$router.push({
              path: "/"
            })
          }
        })
      }  
    },
    methods:{
      reqTest(){
        this.$axios.post("/kaoshi/get_shijuan_info", qs.stringify({...this.obj}) ).then(res => {
            if (res.data.status == "ok") {
              this.data = res.data.data
              this.now = res.data.data.now
              this.dataTest = res.data.data.shijuan_bankuai[0]
              // this.setHalf()
              this.setEnd()  
              this.reqGetAnswers()
            }else{
              this.$message.error({
                message: res.data.errormsg
              })
            }
          })
      },
      reqSubmit(){
        let useTime = this.getTime(this.data.start_time)
        let data = {...this.obj,use_time: useTime,answers: this.answers}
        this.$axios.post("/kaoshi/submit_shijuan",data).then(res => {
            if (res.data.status == "ok") {
              clearTimeout(this.TimeEnd)
              this.$alert(' ', '已交卷，考试结束!', {
                confirmButtonText: '确定',
                showClose:false,
                center: true,
                callback: action => {
                  this.$router.push({
                    path: "/my"
                  })
                }
              })
            }else{
              this.$message.error({
                message: res.data.errormsg  
              })
            }
          })
      },
      reqAnswer(val,id){ 
       let answer = val.toString().charAt(0)
       this.answers[id-156].answer = answer
       let data = {...this.obj, answers: [{shiti_id:id, answer:answer}]}
       this.$axios.post('/kaoshi/submit_question', data).then(res => {
          
          })
      },
      reqGetAnswers(){
        this.$axios.post("/kaoshi/get_saved_answer", qs.stringify({...this.obj}) ).then(res => {
            if (res.data.status == "ok") {
              let arr = res.data.data
              for(let key in arr){
                document.getElementById('is'+key).classList.add('active')
                this.$set(this.answer,key-156,arr[key].answer + key)
                this.answers[key-156].answer = arr[key].answer
              } 
            }else{
              this.$message.error({
                message: res.data.errormsg
              })
            }
            this.loading = false
          })
      },   
      // setTime(){
      //   this.timePlus = setTimeout(() => {
      //     this.now++
      //     this.setTime()
      //   },1000)
      // },
      // setHalf(){  //开考半小时后 可以提交试卷
      //   let half = 30*60
      //   let start = this.data.start_time.replace(/-/g,"/")
      //   let startime = Date.parse(start)/1000;
      //   this.TimeOutHalf = setTimeout( () => {  
      //     if( this.now - startime >= half ){   
      //       clearTimeout(this.TimeOutHalf)
      //       this.flag = false 
      //     }else{
      //       this.setHalf() 
      //     }  
      //   }, 1000)
      // },
      setEnd(){  //当前时间超过规定时间 自动提交试卷
        let half = 30*60
        let start = this.data.start_time.replace(/-/g,"/")
        let end = this.data.start_time.replace(/-/g,"/")
        let startime = Date.parse(start)/1000;
        let endtime = Date.parse(end)/1000;

        this.TimeEnd = setTimeout(() => {  
           this.now++
          if( this.now - startime >= half ){   
            this.flag = false 
          }
          if( this.now - endtime >=0 ){ 
            clearTimeout(this.TimeEnd)
            this.reqSubmit()
          }else{
            this.setEnd() 
            this.countDown  = this.getTime(endtime -this.now)
          }
        }, 1000)
      },
      getTime(time){
        // let n  = new Date().getTime() 
        // let t = new Date(time).getTime()
        // let total = (t>n?t-n:n-t)/1000
        // let afterDay=total%(24 * 60 * 60) 
        let afterDay=time%(24 * 60 * 60)    //计算天数后剩余的毫秒数
        let hours=Math.floor(afterDay/(60*60))   //计算出小时数
        let afterHours=afterDay%(60*60)    //计算小时数后剩余的毫秒数
        let minutes=Math.floor(afterHours/60) //计算相差分钟数
        let seconds=Math.round(afterHours%60)    //计算分钟数后剩余的毫秒数
        let h = !!hours && !(hours===1&&minutes===0)?hours+"小时":''
        let m = !(!minutes&&!hours) ? (minutes===0 ?60:minutes)+"分钟" :''  
        return h + m + seconds+"秒"
      },
      setTo(i){
        let id = 'to'+i
        document.getElementById(id).scrollIntoView({behavior:'smooth',block: "center", inline: "nearest"})  
      },
      getLS(id){
        return localStorage.getItem(id)
      }
    },
    beforeDestroy () {
      // clearTimeout(this.TimeOutHalf)
      clearTimeout(this.TimeEnd)
      // clearTimeout(this.timePlus)
    }
  };
</script>

<style lang="less" scoped>
.r93{width:930px;}
.r72{width:720px;}
.width{width:1200px;margin: 0 auto;}
.width1{width:1000px;margin:0 auto;}
.kaoshi{
  font-size:14px;
  height:100%;
  .title{
    background-color: #AD0008;
    color:#f7e6e6;width:100%;border-bottom: 20px solid #f4f4f4;
    z-index: 99;
  }
  .contanier{
    top:95px;
    .left{
      width:250px;
      h3{
        height:40px;line-height: 40px;background: #eaf5fd;padding-left:20px;
      }
      .top{
        background-color: #fff;  
      }
      .bot{
        background-color: #fff;
        .el-scrollbar{
          max-height: 400px;
          padding:10px 0 15px 2px;  
          /deep/.el-scrollbar__wrap { 
            overflow-x: hidden;
          } 
          .tc{width:35px;height:35px;background:#e6e6e6;margin:5px 0 0 5px; 
            line-height: 35px;cursor: pointer;
            &.active{
              background: #007eff;color:#fff
            }
          }
        }
        button{
          width:100%;
        }
      }
    }
    .right{ 
      padding:15px 15px 30px;
      background-color: #fff;
      left:270px;
      overflow-x: hidden;
      .tit{
        font-size: 16px;
      }
      label{
        display: block;margin-bottom:10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/kaoshi.vue